import { Avatar, Badge, Button, Dropdown, ScrollPanel } from "@/uiCore";
import { InputText } from "primereact/inputtext";
import { useDetailNotice, useListNotice } from "./utils";
import { Splitter, SplitterPanel } from "primereact/splitter";
import { use, useEffect, useRef, useState } from "react";
import { checkRead } from "./api";
import { Skeleton } from "primereact/skeleton";

const DashboardFB = () => {
  const [chosen, setChosen] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [params, setParams] = useState({ isCmt: false });
  const more_options = [
    { name: "Đã xem", code: "read" },
    { name: "Chưa xem", code: "unread" },
    { name: "Tag", code: "tag" },
    { name: "Ẩn", code: "hide" },
  ];
  const list_notice = useListNotice({ ...params, comment: params?.isCmt });
  const data = useDetailNotice({
    from_id: chosen?.from_id,
    comment: params?.isCmt,
  });
  const handleChangeFromId = async (e, post_id) => {
    setChosen({ ...e });
    if (post_id) {
      setParams({ ...params, isCmt: true });
      await checkRead({ comment: true, from_id: e?.from_id });
    } else {
      setParams({ ...params, isCmt: false });
    }
    setTimeout(() => setIsLoading(false), 1000);
  };
  const handleChangeMessage = async () => {
    setParams({ ...params, isCmt: false });
    setChosen({});
  };
  const handleChangeComment = async () => {
    setParams({ ...params, isCmt: true });
    setChosen({});
  };
  const parseTime = (time) => {
    const date = new Date(time);
    const now = new Date();
    const startOfToday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const startOfDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );

    const diffMs = startOfToday - startOfDate;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
      return date.toLocaleTimeString("vi-VN", {
        hour: "2-digit",
        minute: "2-digit",
      });
    }

    if (diffDays <= 6) {
      return `${diffDays} ngày`;
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const checkLastMessage = (item) => {
    if (item?.isMessage) {
      if (item?.messages?.data?.[0]) {
        const data = item?.messages?.data?.[0];
        if (data?.from?.name == "VIC Grand Square") {
          return { isMe: true, message: data?.message };
        } else {
          return { isMe: false, message: data?.message };
        }
      }
    } else {
      return { isMe: false, message: item?.cmt };
    }
  };
  function FacebookPostEmbed({ url }) {
    const containerRef = useRef(null);

    useEffect(() => {
      if (!document.getElementById("facebook-jssdk")) {
        const script = document.createElement("script");
        script.id = "facebook-jssdk";
        script.src =
          "https://connect.facebook.net/vi_VN/sdk.js#xfbml=1&version=v20.0";
        document.body.appendChild(script);
        script.onload = () => {
          if (window.FB) {
            window.FB.init({ xfbml: true, version: "v20.0" });
            window.FB.XFBML.parse(containerRef.current);
          }
        };
      } else {
        if (window.FB) {
          window.FB.XFBML.parse(containerRef.current);
        }
      }
    }, [url]);

    return (
      <div className="flex flex-column" style={{}} ref={containerRef}>
        <div
          className="fb-post"
          data-href={url}
          data-show-text="true"
          data-width="350"
        />
      </div>
    );
  }
  return (
    <div
      className=" w-full flex flex-row pt-3 px-4 "
      style={{ height: "calc(100vh - 6rem)" }}
    >
      <Splitter className="shadow-4 w-full h-full flex border-round-lg">
        <SplitterPanel
          className="  h-full border-right-2 border-300 py-2 flex flex-column"
          size={33}
          minSize={25}
        >
          <div
            className="w-full flex flex-column px-3"
            style={{ height: "10%" }}
          >
            <div className="w-full flex flex-row">
              <div className="w-9 p-2">
                <InputText
                  className="w-full"
                  placeholder="Tìm kiếm khách hàng"
                  icons="pi pi-search"
                />
              </div>
              <div className="w-3 py-2 flex justify-content-center align-items-center">
                <div className=" border-round-lg px-2 py-2 flex flex-row justify-content-center align-items-center cursor-pointer hover:surface-200">
                  <i className="pi pi-sliders-h mr-2"></i>Quản lý
                </div>
              </div>
            </div>
          </div>
          <div
            className="w-full flex flex-column px-3"
            style={{ height: "5%" }}
          >
            <div className="w-full flex flex-row justify-content-between align-items-center mt-2 px-2">
              <div
                className={`border-round-lg px-2 py-2 flex flex-row justify-content-center align-items-center cursor-pointer ${
                  params?.isCmt
                    ? "surface-100 hover:surface-300"
                    : "bg-blue-400 text-white hover:bg-blue-500"
                }`}
                onClick={() => handleChangeMessage()}
              >
                <i className="pi pi-send mr-2"></i>Tin nhắn
              </div>
              <div
                className={`border-round-lg px-2 py-2 flex flex-row justify-content-center align-items-center cursor-pointer ${
                  !params?.isCmt
                    ? "surface-100 hover:surface-300"
                    : "bg-blue-400 text-white hover:bg-blue-500"
                }`}
                onClick={() => handleChangeComment()}
              >
                <i className="pi pi-comments mr-2"></i>Bình luận
              </div>
              {/* <div className=" border-round-lg px-2 py-2 flex flex-row justify-content-center align-items-center cursor-pointer hover:surface-200">
                <i className="pi pi-filter-fill mr-2"></i>Bộ lọc thêm{" "}
              </div> */}
              <Dropdown
                value={params?.moreOption}
                onChange={(e) => setParams({ ...params, moreOption: e.value })}
                options={more_options}
                optionLabel="name"
                optionValue="code"
                placeholder="More"
                className=""
                checkmark={true}
                highlightOnSelect={false}
              />
            </div>
          </div>
          <ScrollPanel className="w-full pt-3" style={{ height: `85%` }}>
            {[...list_notice].map((item) => {
              const lastMessage = checkLastMessage(item);
              return (
                <div
                  className="w-full flex flex h-6rem justify-content-between align-items-center px-3 py-1 cursor-pointer hover:surface-100"
                  onClick={() => handleChangeFromId(item, item?.post_id)}
                >
                  <div className="flex flex-row ">
                    <div className="flex flex-row px-2 align-items-center">
                      <Avatar
                        image={item?.image}
                        size="xlarge"
                        shape="circle"
                      />
                      <div className="flex flex-column ml-3 gap-2 mt-1">
                        <span
                          className={`${
                            item?.nullReadCount > 0
                              ? "font-bold text-700"
                              : "font-semibold"
                          } text-md`}
                        >
                          {item?.from_name}
                        </span>
                        <div className="flex flex-row align-items-center">
                          {item?.post_id && (
                            <span
                              className={`${
                                item?.nullReadCount > 0
                                  ? "font-semibold text-700"
                                  : "text-400 medium"
                              } text-sm mr-2`}
                            >
                              Bình luận:
                            </span>
                          )}
                          <span
                            className={` ${
                              item?.nullReadCount > 0
                                ? "font-bold text-700"
                                : "text-400 medium"
                            } text-sm`}
                          >
                            {item?.message}
                          </span>
                        </div>
                        <div className="flex flex-row gap-2 align-items-center">
                          <Avatar
                            image={item?.avatar}
                            shape="circle"
                            style={{ width: "20px", height: "20px" }}
                          />
                          <span className="font-semibold text-blue-500 text-sm">
                            {item?.page_name}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex"></div>
                  </div>
                  <div className="py-2 h-full flex flex-column gap-3">
                    <span className="text-500 text-sm">
                      {parseTime(item.created_time)}
                    </span>
                    <div className="flex flex-row justify-content-center align-items-center">
                      {item?.nullReadCount > 0 && (
                        <Badge
                          value={item?.nullReadCount}
                          size="normal"
                          severity="danger"
                        ></Badge>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </ScrollPanel>
        </SplitterPanel>
        {chosen?.from_id ? (
          <SplitterPanel className="flex flex-column" size={67} minSize={50}>
            <div
              className="w-full flex flex-row border-bottom-2 border-300 px-3 py-2 align-items-center"
              style={{ height: "10%" }}
            >
              <div className="flex flex-row px-2">
                <Avatar image={""} size="xlarge" shape="circle" />
                <div className="flex flex-column ml-3 gap-2 mt-1">
                  <span className="font-bold text-xl">{chosen?.from_name}</span>
                  <span className="text-500 font-semibold text-blue-400">
                    {chosen?.page_name}
                  </span>
                </div>
              </div>
            </div>
            <div className="w-full flex flex-column" style={{ height: "90%" }}>
              {/* Danh sách tin nhắn */}
              <div
                className="flex flex-column gap-3 overflow-auto flex-grow-1 p-3"
                style={{ height: "90%" }}
              >
                <div></div>
                {data?.map((item) => (
                  <div className="flex flex-column gap-3">
                    <div className="flex flex-row ">
                      <div className="" style={{ width: "70px" }}></div>
                      <FacebookPostEmbed url={item?.link} />
                    </div>
                    <div className="flex flex-row ">
                      <div
                        className="flex justify-content-center"
                        style={{ width: "70px" }}
                      >
                        <Avatar
                          image={item?.from?.image}
                          style={{ width: "50px", height: "50px" }}
                          shape="circle"
                        />
                      </div>
                      <div
                        className="text-md text-500 p-3 border-round-lg w-auto "
                        style={{ maxWidth: "350px", background: "#f0f0f0" }}
                      >
                        {item?.message || ""}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {chosen?.post_id ? (
                <></>
              ) : (
                <div
                  className="flex flex-row gap-2 p-3"
                  style={{ height: "10%" }}
                >
                  <InputText
                    className="w-full"
                    placeholder="Nhập tin nhắn..."
                    icons="pi pi-search"
                  />
                  <Button label="Gửi" />
                </div>
              )}
            </div>
          </SplitterPanel>
        ) : (
          <SplitterPanel
            className="flex flex-column justify-content-center align-items-center"
            size={67}
            minSize={50}
          ></SplitterPanel>
        )}
      </Splitter>
    </div>
  );
};
export default DashboardFB;
